import React, { useEffect, useState } from "react";
import "../../../assets/scss/components/myApp.scss";
import "../../../assets/scss/vendor_scss/MySubscriptions.scss";
import appUrl from "../../../config/MyApp/myAppsURLConfig";

import SubscriptionsList from "../../../components/VendorComponents/MySubscriptions/SubscriptionsList";
import SubscriptionForm from "../../../components/VendorComponents/MySubscriptions/SubscriptionForm";
import Loader from "../../../components/generic/loader";
import NoAppComponent from "../../../components/CommonCompnents/NoAppComponent";
import ErrorMsg from "../../../components/CommonCompnents/ErrorMsg";
import {
  addTolocalStorage,
  constants,
  errorsMsg,
  getTolocalStorage,
  removeServerErrors,
} from "../../Constants/commenFeatures";
import {
  APITypes,
  SubscriptionFrom,
  SubscriptionFromError,
  SubscriptionFromValue,
  TITLE,
  getAppIcon,
} from "./subscriptionsConstent";
import {
  vendorCreateApp,
  vendorGetAllApps,
  vendorModifyApp,
} from "../../../services/MyApps/myAppServise";
import useDocumentTitle from "../../../utils/useDocumentTitle";

export interface IMySubscriptionsProps {}

const MySubscriptions: React.FC<IMySubscriptionsProps> = () => {
  const [userId, setUserId] = useState<string>();
  const [mySubApps, setMySubApps] = useState<any>(null);
  const [isLoader, setIsLoader] = useState<boolean>(true);
  const [isServerErr, setIsServerErr] = useState({
    successRes: "",
    failedRes: "",
    limitExceeded: "",
  });
  const [isSubFrom, setIsSubForm] = useState<any>({
    isOpen: false,
    title: "",
    appData: "",
  });
  const [subscriptionFrom, setSubscriptionFrom] = useState<SubscriptionFrom>(
    JSON.parse(JSON.stringify(SubscriptionFromValue))
  );

  const [subscriptionFromErr, setSubscriptionFromErr] = useState(
    JSON.parse(JSON.stringify(SubscriptionFromError))
  );
    useDocumentTitle("My Subscriptions - Manage API Access");
  const [ipCount, setIpCount] = useState<number>(1);

  const handelSubscriptionModal = (
    isOpen: boolean,
    title: string,
    appData: any
  ) => {
    setIsSubForm({
      isOpen: isOpen,
      title: title,
      appData: appData,
    });
    setSubscriptionFrom(JSON.parse(JSON.stringify(SubscriptionFromValue)));
    setSubscriptionFromErr(JSON.parse(JSON.stringify(SubscriptionFromError)));
  };

  const mySubAppsRes = (res: any) => {
    if (res && res.data) {
      setMySubApps(res.data);
      addTolocalStorage("apiKey", res.data.apiKey);
      addTolocalStorage("appNm", res.data.appNm);
    } else if (res && res.error) {
      setMySubApps("");
      setIsServerErr({
        successRes: "",
        failedRes: res.error.errMsg || errorsMsg.commonError,
        limitExceeded: "",
      });
    } else {
      setIsServerErr({
        successRes: "",
        failedRes: errorsMsg.commonError,
        limitExceeded: "",
      });
    }
    setIsLoader(false);
  };

  const submitCreateAppRes = (res: any) => {
    setSubscriptionFrom(SubscriptionFromValue);
    if (res && res.error) {
      setIsLoader(false);
      setIsServerErr({
        ...isServerErr,
        failedRes: res.error.errMsg || errorsMsg.commonError,
      });
    } else if (res && res.data) {
      vendorGetAllApps(mySubAppsRes, userId);
      setIsServerErr({
        ...isServerErr,
        successRes: res.data.msg,
      });
    } else {
      setIsServerErr({
        ...isServerErr,
        failedRes: errorsMsg.commonError,
      });
    }
  };

  const submitFromHandler = async () => {
    handelSubscriptionModal(false, "", "");
    if (isSubFrom.title === TITLE.CREATE) {
      const body: any = {
        appNm: subscriptionFrom.appNm,
        rdUrl: window.btoa(subscriptionFrom.rdUrl),
        type: subscriptionFrom.type,
        ldId: userId,
        primaryIp: window.btoa(subscriptionFrom.primaryIp || ""),
        secondaryIp: window.btoa(subscriptionFrom.secondaryIp || ""),
        isAlgoVendor: subscriptionFrom.isAlgoVendor
      };
      // if (!subscriptionFrom.ip.includes("")) {
      //   body.ip = subscriptionFrom.ip.map((ip: any) => {
      //     return window.btoa(ip);
      //   });
      // }

      if (subscriptionFrom.appIcon && subscriptionFrom.appIcon !== "") {
        let getBaseIcon = (value: string) => {
          body.flCntnt = value;
          body.flNm = subscriptionFrom.appIcon.name;
          vendorCreateApp(submitCreateAppRes, userId, body);
        };
        await getAppIcon(subscriptionFrom.appIcon, getBaseIcon);
      } else {
        vendorCreateApp(submitCreateAppRes, userId, body);
      }
    } else {
      const body: any = {
        apiKey: isSubFrom.appData.apiKey,
        vendNm: subscriptionFrom.appNm,
        rdUrl: window.btoa(subscriptionFrom.rdUrl),
        type: subscriptionFrom.type,
        primaryIp: window.btoa(subscriptionFrom.primaryIp || ""),
        secondaryIp: window.btoa(subscriptionFrom.secondaryIp || ""),
        ldId: userId,
        isAlgoVendor: subscriptionFrom.isAlgoVendor
      };
      // if (!subscriptionFrom.ip.includes("")) {
      //   body.ip = subscriptionFrom.ip.map((ip: any) => {
      //     return window.btoa(ip);
      //   });
      // }
      if (subscriptionFrom.appIcon && subscriptionFrom.appIcon !== "") {
        let getBaseIcon = (value: string) => {
          body.flCntnt = value;
          body.flNm = subscriptionFrom.appIcon.name;
          vendorModifyApp(submitCreateAppRes, userId, body);
        };
        await getAppIcon(subscriptionFrom.appIcon, getBaseIcon);
      } else {
        vendorModifyApp(submitCreateAppRes, userId, body);
      }
    }
  };

  const removeIsServerErrors = () => {
    setIsServerErr({
      successRes: "",
      failedRes: "",
      limitExceeded: "",
    });
  };

  useEffect(() => {
    async function callOnLoad() {
      let getldId = await getTolocalStorage("ldID");
      if (getldId !== undefined && getldId) {
        await setUserId(getldId);
        vendorGetAllApps(mySubAppsRes, getldId);
      }
    }
    callOnLoad();
  }, []);

  useEffect(() => {
    if (
      isServerErr.successRes !== "" ||
      isServerErr.failedRes !== "" ||
      isServerErr.limitExceeded !== ""
    ) {
      removeServerErrors(removeIsServerErrors, constants.ErrorTimeout);
    }
  }, [isServerErr]);

  useEffect(() => {
    async function getEditableData() {
      if (isSubFrom.title === TITLE.EDIT) {
        let getIPs = [];
        if (isSubFrom.appData.ip && isSubFrom.appData.ip.length > 0) {
          let ipData = isSubFrom.appData.ip.split(",");
          await setIpCount(ipData.length);
          for (let i = 1; i <= ipData.length; i++) {
            getIPs.push(ipData[i - 1]);
          }
        }
        setSubscriptionFrom({
          // ip: getIPs,
          appNm: isSubFrom.appData.appNm ? isSubFrom.appData.appNm : "",
          rdUrl: isSubFrom.appData.rdUrl ? isSubFrom.appData.rdUrl : "",
          appIcon: "",
          iconView: isSubFrom.appData.flLnk
            ? appUrl.appIcon + isSubFrom.appData.flLnk
            : "",
          type: isSubFrom.appData.type ? isSubFrom.appData.type : "",
          primaryIp: isSubFrom.appData.primaryIp || "",
          secondaryIp: isSubFrom.appData.secondaryIp || "",
          ipEditable:  isSubFrom.appData.addStaticIpLink ? true : isSubFrom.appData.ipEditable || false,
          isAlgoVendor: isSubFrom.appData.isAlgoVendor
        });
      } else {
        setSubscriptionFrom(JSON.parse(JSON.stringify(SubscriptionFromValue)));
      }
    }
    getEditableData();
  }, [isSubFrom.appData]);

  return (
    <div>
      {isLoader ? (
        <div className="full_Loader">
          <Loader size={50} color="blue"></Loader>
        </div>
      ) : (
        <div>
          <ErrorMsg isServerErr={isServerErr} />
          <div>
            <div>
              {mySubApps ? (
                <SubscriptionsList
                  subscribedApps={mySubApps}
                  handelSubscriptionModal={handelSubscriptionModal}
                />
              ) : (
                <NoAppComponent
                  appFormHandler={handelSubscriptionModal}
                  title={TITLE.CREATE}
                />
              )}
            </div>
          </div>
        </div>
      )}

      {/* Create App Modal */}
      <SubscriptionForm
        isSubFrom={isSubFrom}
        handelSubscriptionModal={handelSubscriptionModal}
        APITypes={APITypes}
        onChangeFormVal={setSubscriptionFrom}
        subscriptionFrom={subscriptionFrom}
        setSubscriptionFromErr={setSubscriptionFromErr}
        subscriptionFromErr={subscriptionFromErr}
        ipCount={ipCount}
        setIpCount={setIpCount}
        submitFromHandler={submitFromHandler}
      />
    </div>
  );
};

export default MySubscriptions;
